import { CONSTANTS } from '../../constants/constants';
import customTheme from '../customTheme';
import NRColoredBar from '../NRColoredBar/NRColoredBar';
import { encodeParam } from '../../services/params.utils';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { removeTabAndSubTabFromFilePath } from '../../services/urlInterceptor.utils';
const { EQUAL } = CONSTANTS.FILTER_OPERATIONS;

/**
 * @param values = {low: int, medium: int, high: int, critical: int}
 * @param name
 * @param vendor
 * @param version
 * @param extraHandleOnClick
 * @param showTotal
 * @returns {JSX.Element}
 */
function NRColoredBarVulnerabilitiesContainer({ values, name, vendor, version, extraHandleOnClick, showTotal, isLoading, disableOnClick = false }) {
  const [redirectToParams, setRedirectToParams] = useState();

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    !!redirectToParams &&
      navigate(`${removeTabAndSubTabFromFilePath(location)}/${CONSTANTS.REPORT.TABS.VULNERABILITIES}?${redirectToParams.toString()}`);
  }, [redirectToParams]);

  function handleOnClick(vulnerabilitiesCount, severity) {
    if (disableOnClick) return;
    if (vulnerabilitiesCount === 0) return;
    let extraParams = new URLSearchParams();
    let filterFields = [];

    if (!!severity) {
      extraParams.append('vulnerabilitySeverityFilter', encodeParam([severity.toUpperCase()]));
    }
    if (!!name) {
      filterFields.push({
        fieldName: 'NAME',
        value: name,
        operation: EQUAL
      });
    }
    if (!!vendor) {
      filterFields.push({
        fieldName: 'VENDOR',
        value: vendor,
        operation: EQUAL
      });
    }
    if (!!version) {
      filterFields.push({
        fieldName: 'VERSION',
        value: version,
        operation: EQUAL
      });
    }
    if (!!filterFields.length) {
      extraParams.append('vulnerabilityColumnFilter', encodeParam(filterFields));
    }
    if (extraHandleOnClick) {
      extraHandleOnClick();
    }
    setRedirectToParams(extraParams);
  }

  const coloredBarConfig = [
    {
      title: CONSTANTS.SEVERITIES.LOW,
      value: values?.low || 0,
      action: () => handleOnClick(values.low, CONSTANTS.SEVERITIES.LOW),
      color: customTheme.palette.severityPalette[2].main
    },
    {
      title: CONSTANTS.SEVERITIES.MEDIUM,
      value: values?.medium || 0,
      action: () => handleOnClick(values.medium, CONSTANTS.SEVERITIES.MEDIUM),
      color: customTheme.palette.severityPalette[3].main
    },
    {
      title: CONSTANTS.SEVERITIES.HIGH,
      value: values?.high || 0,
      action: () => handleOnClick(values.high, CONSTANTS.SEVERITIES.HIGH),
      color: customTheme.palette.severityPalette[4].main
    },
    {
      title: CONSTANTS.SEVERITIES.CRITICAL,
      value: values?.critical || 0,
      action: () => handleOnClick(values.critical, CONSTANTS.SEVERITIES.CRITICAL),
      color: customTheme.palette.severityPalette[5].main
    }
  ];

  return (
    <NRColoredBar
      innerKey={`${name}`}
      config={coloredBarConfig}
      disableOnClick={disableOnClick}
      handleOnTotalClick={!disableOnClick ? () => handleOnClick(values?.CRITICAL, null) : undefined}
      showTotal={showTotal}
      isLoading={isLoading}
    />
  );
}

export default NRColoredBarVulnerabilitiesContainer;
